import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/manga';

export default function LatestUpdates() {
  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">
              最新更新
            </span>
            <h2 className="mt-2 text-3xl md:text-4xl font-bold font-heading text-foreground-950">
              新鲜出炉 · <span className="text-accent-500">即刻追更</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              每日更新热门韩漫，追更不等待
            </p>
          </div>
          <Link
            to="/category/lianai"
            className="mt-4 md:mt-0 inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 -mx-6 md:-mx-10 px-6 md:px-10 scrollbar-hide">
          {latestUpdates.map((manga) => (
            <Link
              key={manga.id}
              to={`/manga/${manga.id}`}
              className="flex-shrink-0 w-[200px] md:w-[220px] group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-200">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  title={manga.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {manga.status === '连载中' && (
                  <span className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-accent-500 text-foreground-950 text-xs font-bold">
                    连载
                  </span>
                )}
              </div>
              <div className="mt-3">
                <p className="text-xs text-foreground-500 mb-1">{manga.genres[0]}</p>
                <h3 className="text-sm font-bold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
                  {manga.title}
                </h3>
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center gap-1">
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-star-fill text-xs text-accent-500"></i>
                    </div>
                    <span className="text-xs font-semibold text-foreground-700">{manga.rating}</span>
                  </div>
                  <span className="text-xs text-foreground-500">
                    {manga.viewCount > 10000
                      ? `${(manga.viewCount / 10000).toFixed(0)}万`
                      : manga.viewCount}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}